import { createStore, compose, applyMiddleware, combineReducers } from 'redux'
import createSagaMiddleware from 'redux-saga'
import watchSagas from './sagaListeners'

import userReducer from './user/userReducer'

const sagaMiddleware = createSagaMiddleware()

const rootReducer = combineReducers({
  user: userReducer,
})

const store = createStore(rootReducer, compose(applyMiddleware(sagaMiddleware)))
sagaMiddleware.run(watchSagas).toPromise().catch()

export default store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
